import { MoveToFolder } from 'ui/icons';
import { AmazonS3, BigQuery, Databricks, Redshift } from 'ui/thirdPartyLogos';
import { DestinationDetail } from '../types/types';

/**
 * Warehouse destinations for BETA
 *
 * Databricks
 * BigQuery
 * S3
 * Redshift
 * SFTP
 *
 * https://docs.prequel.co/docs/destinations-overview
 *
 */
export const DESTINATIONS_LIST: { [key: string]: DestinationDetail } = {
  bigquery: {
    Icon: BigQuery,
    id: 'bigquery',
    name: 'BigQuery',
  },
  databricks: {
    Icon: Databricks,
    id: 'databricks',
    name: 'Databricks',
  },
  redshift: {
    Icon: Redshift,
    id: 'redshift',
    name: 'Amazon Redshift',
  },
  s3: {
    Icon: AmazonS3,
    id: 's3',
    name: 'Amazon S3',
  },
  sftp: {
    Icon: MoveToFolder,
    id: 'sftp',
    name: 'SFTP',
  },
};

export const PREQUEL_HOST = 'https://api.prequel.co';
